import { NavLink, useSearchParams } from 'react-router-dom';

import ProjectFilter from '../../projects/layouts/project-filter';
import ApiReferenceTab from './api-reference';

import '../styles/documentation.css';

// Documentación: what a project has written down about itself.
//
// PER PROJECT, ALWAYS. A document belongs to one project in Core — its vision,
// its architecture, its API reference — so the section starts by asking which
// one, and the choice travels in `?project=` across tabs like it does in
// Desarrollo.
//
// One tab today, the API reference. The rest of the document kinds (`vision`,
// `architecture`, `ui_guide`, `manual`, `glossary`, `decision`…) are tabs that
// have not been drawn yet; the section is built to take them as rows of TABS.

const TABS = [
    { key: 'api-reference', title: 'API Reference' },
];

export default function DocumentationScreen({ tab = 'api-reference' }) {
    const [params, setParams] = useSearchParams();
    const projectId = params.get('project') || '';
    const current = TABS.some(item => item.key === tab) ? tab : TABS[0].key;

    // Changing project drops what belonged to the previous one: its chosen
    // document and the filters over its routes.
    const setProject = (value) => {
        const target = new URLSearchParams();
        if (value) target.set('project', value);
        setParams(target);
    };

    const carry = projectId ? `?project=${projectId}` : '';

    return (
        <section className="documentation">
            <header className="documentation__header">
                <div className="documentation__heading">
                    <span className="documentation__eyebrow">Lo que el proyecto dejó escrito</span>
                    <h2 className="documentation__title">Documentación</h2>
                </div>
                <ProjectFilter value={projectId} onChange={setProject} all="Elegí un proyecto" />
            </header>

            <nav className="documentation__tabs" aria-label="Secciones de documentación">
                {TABS.map(item => (
                    <NavLink
                        key={item.key}
                        to={`/admin/documentation/${item.key}${carry}`}
                        className={() => `documentation__tab ${item.key === current ? 'documentation__tab--active' : ''}`}
                        aria-current={item.key === current ? 'page' : undefined}
                    >
                        {item.title}
                    </NavLink>
                ))}
            </nav>

            <div className="documentation__panel">
                {current === 'api-reference' && <ApiReferenceTab projectId={projectId} />}
            </div>
        </section>
    );
}
